export default {
    enableGenderSelection: true,
    ageConsentCountries: ['KR'],
    tcConsentCountries: ['KR'],
    gdprLikeCountries: ['RU'],
    links: {
        termsAndConditions: '/en-gb/content/help/terms-and-conditions/',
        privacyPolicy: '/en-gb/content/help/privacy-policy/',
    },
    orderRef: '3103ZDS0H2321J',
    shippingAddress: {
        addressId: 240187746859241,
        nickName: 'Test:User:SE88ES:1680269120286',
        personTitle: 'Mr',
        firstName: 'Test',
        lastName: 'User',
        addressLine: ['Street Name', '', ''],
        city: 'London',
        zipCode: 'SE88ES',
        state: 'Aberdeenshire',
        stateOrProvinceName: 'Aberdeenshire',
        country: 'GB',
        phone1: '11111111',
        transient: true,
        countryName: 'United Kingdom',
        stateName: 'Aberdeenshire',
    },
    shippingOption: {
        fulfillmentCenterName: 'GB-LN-DC1',
        id: 715839112,
        name: 'Next Day',
        nameEN: 'next day delivery',
        shipModeCode: 'NEXT_DAY_DELIVERY',
        available: true,
        description: ['Order by 3pm GMT', 'Weekend orders after 3pm Friday will arrive on Tuesday'],
        finalShippingPrice: '£8',
        originalShippingPrice: '',
        signature: 'optional',
        defaultSignatureRequired: 'N',
        selected: true,
        defaultNominatedSlot: '',
        getFormattedSlot: null,
    },
    shippingOptionInfo: {
        currentSignatureRequired: 'N',
        getRequestedSlot: null,
    },
    shippingOptionInfoJit: {
        getRequestedSlot: null,
    },
    paymentOption: {
        id: 'CREDIT_CARD/a5f6f460-374d-4b86-be96-f1700ecf27f8',
        cardId: 'a5f6f460-374d-4b86-be96-f1700ecf27f8',
        type: 'VISA',
        expireMonth: '03',
        expireYear: '30',
        lastFourDigits: '1111',
        addressLine: 'Street Name',
        selected: true,
        returnUrl: 'http://localhost:8081/en-gb/checkout/authorise',
        cancelUrl: 'http://localhost:8081/en-gb/checkout/authorise',
        browserInfo: {
            screenWidth: '1792',
            timeZoneOffset: '-60',
            language: 'en-GB',
            javaEnabled: 'false',
            screenHeight: '1120',
            colorDepth: '30',
            userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/111.0.0.0 Safari/537.36',
        },
        card_holder: {
            country: 'GB',
            address: 'Street Name',
            province: 'Aberdeenshire',
            city: 'London',
            name: 'Test User',
            postal_code: 'SE88ES',
        },
    },
    billingAddress: {
        addressId: 240187746859241,
        nickName: 'Test:User:SE88ES:1680269120286',
        personTitle: 'Mr',
        firstName: 'Test',
        middleName: '',
        lastName: 'User',
        addressLine: ['Street Name', '', ''],
        city: 'London',
        zipCode: 'SE88ES',
        state: 'Aberdeenshire',
        stateOrProvinceName: 'Aberdeenshire',
        country: 'GB',
        phone1: '11111111',
        phone2: '',
        transient: true,
        countryName: 'United Kingdom',
        stateName: 'Aberdeenshire',
    },
    userStatus: 'G',
    lineItems: [
        {
            partNumber: '0400501633231',
            productId: '12746486952148898',
            orderItemId: 23522000,
            image: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w960.jpg',
            imageObject: {
                id: 'in',
                url: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w60.jpg',
                zoomUrl: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w60.jpg',
                srcSet: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w60.jpg 60w',
                zoomSrcSet: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w60.jpg 60w',
                alt: 'Lacoste Cotton-Piqué Polo Shirt',
            },
            name: 'Cotton-Piqué Polo Shirt',
            nameEN: 'Cotton-Piqué Polo Shirt',
            brand: 'YEEZY GAP ENGINEERED BY BALENCIAGA',
            brandId: 'LACOSTE',
            colour: 'Claret',
            size: '2',
            quantity: 1,
            quantityInStock: 17,
            badges: [{}],
            orderLevelDiscounts: [],
            price: {
                priceReduced: false,
                originalPrice: '£1,500',
                promotions: [],
                currency: 'GBP',
                lineLevelTaxesEnabled: true,
                DDPIncludedCountry: false,
                DDPCountry: false,
                rawFinalPrice: 1500,
                rawUnitPrice: 1500,
                xitem_baseOrderItemPrice: 1250,
                fullPrice: 1500,
                taxAndDuty: 0,
                displayPriceExTaxDuty: 1500,
                priceExTaxDutyWithCurrency: '£1,500',
                discountAmount: 0,
                rawShippingTax: 0,
                isMarkdownPrice: true,
                percentDiscount: 0,
            },
            category: {
                primaryCategory: '衣類',
                subCategory1: 'カジュアルシャツ',
                subCategory2: 'チェックシャツ',
                ids: ['3074457345616677784', '3074457345616677872', '3074457345616677876'],
            },
            onSale: false,
            onPromo: false,
            genericTotal: [
                {
                    name: 'adjustedOrderItemPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedShippingCharge',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 800,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedUnitPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasUnitPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasOrderItemPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'listUnitPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedOrderItemPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedOrderItemPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedShippingCharge_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 913,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedShippingCharge_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 917,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedUnitPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedUnitPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasUnitPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasUnitPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasOrderItemPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasOrderItemPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'listUnitPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'listUnitPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'OrderItemPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'OrderItemPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'SalesTax_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'SalesTax_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'ShippingCharge_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 913,
                        divisor: 100,
                    },
                },
                {
                    name: 'ShippingCharge_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 917,
                        divisor: 100,
                    },
                },
                {
                    name: 'ShippingTax_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'ShippingTax_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'TotalAdjustment_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'TotalAdjustment_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'UnitPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'UnitPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
            ],
            isReservation: false,
            reservationExpiryDate: null,
            isHazardous: false,
            finalSale: false,
            isJIT: false,
            salestax: {
                amount: 0,
                divisor: 100,
            },
            analyticsAttributes: {
                name: 'Cotton-Piqué Polo Shirt',
                sustainabilityFlag: false,
                category: {
                    primaryCategory: '衣類',
                    subCategory1: 'カジュアルシャツ',
                    subCategory2: 'チェックシャツ',
                    ids: ['3074457345616677784', '3074457345616677872', '3074457345616677876'],
                },
                gender: 'womens',
            },
            productUrl: '/en-gb/mens/lacoste/clothing/checked-shirts/cotton-pique-polo-shirt/12746486952148898',
            gtin: '3074457345616690866',
        },
    ],
    numItems: 1,
    totals: {
        currency: 'GBP',
        finalShippingPrice: '£8',
        rawShippingPrice: 8,
        itemTotal: '£1,500',
        rawItemTotal: 1500,
        promotions: [],
        rawTax: 0,
        total: '£1,508',
        rawTotal: 1508,
        grandTotal: '£1,508',
        rawGrandTotal: 1508,
        shippingCharge: '£8',
        orderTaxes: {},
        rawOrderTaxes: {},
        priceWithPromotion: 1500,
        priceWithTax: '£1,500',
        rawPriceWithTax: 1500,
        priceWithShippingTax: 1508,
        codChargeAmount: 0,
        itemSubtotalExTaxDuty: 1500,
        selectedShippingOption: {
            fulfillmentCenterName: 'GB-LN-DC1',
            id: 715839112,
            name: 'Next Day',
            nameEN: 'next day delivery',
            shipModeCode: 'NEXT_DAY_DELIVERY',
            available: true,
            description: ['Order by 3pm GMT', 'Weekend orders after 3pm Friday will arrive on Tuesday'],
            finalShippingPrice: '£8',
            originalShippingPrice: '',
            signature: 'optional',
            defaultSignatureRequired: 'N',
            selected: true,
            defaultNominatedSlot: '',
            getFormattedSlot: null,
        },
    },
    deviceType: '',
    email: 'testemail999@ynap.com',
    currentPackagingOption: {
        name: 'Signature',
        description: 'Signature',
        price: 'Free',
        selected: true,
    },
    saleItemsInOrder: false,
    cardTypeInfo: {
        cardType: 'visa',
        cvvType: 'CVV',
        cvvSize: 3,
    },
    donationAvailable: true,
    donationCharities: ['Movember'],
    isGift: 'N',
    hasJITItems: false,
    remoteItems: [],
    localItems: [
        {
            partNumber: '0400501633231',
            productId: '12746486952148898',
            orderItemId: 23522000,
            image: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w960.jpg',
            imageObject: {
                id: 'in',
                url: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w60.jpg',
                zoomUrl: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w60.jpg',
                srcSet: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w60.jpg 60w',
                zoomSrcSet: '//iris-integ.dev.product.ext.net-a-porter.com/mrp/12746486952148898/in/w60.jpg 60w',
                alt: 'Lacoste Cotton-Piqué Polo Shirt',
            },
            name: 'Cotton-Piqué Polo Shirt',
            nameEN: 'Cotton-Piqué Polo Shirt',
            brand: 'YEEZY GAP ENGINEERED BY BALENCIAGA',
            brandId: 'LACOSTE',
            colour: 'Claret',
            size: '2',
            quantity: 1,
            quantityInStock: 17,
            badges: [{}],
            orderLevelDiscounts: [],
            price: {
                priceReduced: false,
                originalPrice: '£1,500',
                promotions: [],
                currency: 'GBP',
                lineLevelTaxesEnabled: true,
                DDPIncludedCountry: false,
                DDPCountry: false,
                rawFinalPrice: 1500,
                rawUnitPrice: 1500,
                xitem_baseOrderItemPrice: 1250,
                fullPrice: 1500,
                taxAndDuty: 0,
                displayPriceExTaxDuty: 1500,
                priceExTaxDutyWithCurrency: '£1,500',
                discountAmount: 0,
                rawShippingTax: 0,
                isMarkdownPrice: true,
                percentDiscount: 0,
            },
            category: {
                primaryCategory: '衣類',
                subCategory1: 'カジュアルシャツ',
                subCategory2: 'チェックシャツ',
                ids: ['3074457345616677784', '3074457345616677872', '3074457345616677876'],
            },
            onSale: false,
            onPromo: false,
            genericTotal: [
                {
                    name: 'adjustedOrderItemPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedShippingCharge',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 800,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedUnitPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasUnitPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasOrderItemPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'listUnitPrice',
                    currency: {
                        symbol: '£',
                        label: 'GBP',
                    },
                    value: {
                        amount: 150000,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedOrderItemPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedOrderItemPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedShippingCharge_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 913,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedShippingCharge_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 917,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedUnitPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'adjustedUnitPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasUnitPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasUnitPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasOrderItemPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'wasOrderItemPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'listUnitPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'listUnitPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'OrderItemPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'OrderItemPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
                {
                    name: 'SalesTax_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'SalesTax_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'ShippingCharge_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 913,
                        divisor: 100,
                    },
                },
                {
                    name: 'ShippingCharge_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 917,
                        divisor: 100,
                    },
                },
                {
                    name: 'ShippingTax_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'ShippingTax_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'TotalAdjustment_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'TotalAdjustment_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 0,
                        divisor: 100,
                    },
                },
                {
                    name: 'UnitPrice_Annualised_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171102,
                        divisor: 100,
                    },
                },
                {
                    name: 'UnitPrice_Daily_EUR',
                    currency: {
                        symbol: '€',
                        label: 'EUR',
                    },
                    value: {
                        amount: 171934,
                        divisor: 100,
                    },
                },
            ],
            isReservation: false,
            reservationExpiryDate: null,
            isHazardous: false,
            finalSale: false,
            isJIT: false,
            salestax: {
                amount: 0,
                divisor: 100,
            },
            analyticsAttributes: {
                name: 'Cotton-Piqué Polo Shirt',
                sustainabilityFlag: false,
                category: {
                    primaryCategory: '衣類',
                    subCategory1: 'カジュアルシャツ',
                    subCategory2: 'チェックシャツ',
                    ids: ['3074457345616677784', '3074457345616677872', '3074457345616677876'],
                },
                gender: 'womens',
            },
            productUrl: '/en-gb/mens/lacoste/clothing/checked-shirts/cotton-pique-polo-shirt/12746486952148898',
            gtin: '3074457345616690866',
        },
    ],
    deliveryDuty: '',
    isPostSplit: false,
    donationOrderId: '5534033486711728680',
    multipleLanguageCountries: {
        AE: ['en', 'ar'],
        AT: ['de', 'en'],
        BH: ['en', 'ar'],
        DE: ['de', 'en'],
        GB: ['de', 'fr', 'en'],
        GG: ['de', 'fr', 'en'],
        JP: ['ja', 'en'],
        KR: ['ko', 'en'],
        KW: ['en', 'ar'],
        OM: ['en', 'ar'],
        QA: ['en', 'ar'],
        SA: ['en', 'ar'],
        SY: ['ja', 'de', 'en', 'ar'],
        US: ['de', 'fr', 'en'],
    },
}
